import { HttpErrorResponse, HttpEventType, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { catchError, switchMap, tap, throwError } from 'rxjs';
import { TokenModel } from '../models/token.model';
import { Api } from '../../core/constants/api.constants';

function extractErrorMessage(err: HttpErrorResponse): string {
  if (err.error instanceof ErrorEvent) {
    return 'Ocurrió un error de conexión. Inténtalo de nuevo.';
  }
  const message = err.error?.message;
  if (Array.isArray(message)) {
    return message.join(', ');
  }
  if (typeof message === 'string' && message) {
    return message;
  }
  return 'Ocurrió un error inesperado. Inténtalo de nuevo.';
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Inject the current `AuthService` and use it to get an authentication token:
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);
  // console.log('req: ', req.url);
  const authHeaders = authService.getAuthHeaders(req.headers);
  // Clone the request to add the authentication header.
  const request = req.clone({
    headers: authHeaders,
  });
  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && err.url !== `${Api.url.base}auth/login`) {
        return authService.refreshToken().pipe(
          switchMap((newToken) => {
            const newReq = request.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken.access_token}`
              }
            });
            return next(newReq);
          }),
          catchError((refreshErr: HttpErrorResponse) => {
            if (refreshErr.status === 429) {
              authService.logout();
              notificationService.error('Demasiados intentos. Por favor inicia sesión de nuevo.');
              return throwError('Could not refresh token. Please log in again.');
            } else {
              notificationService.error(extractErrorMessage(refreshErr));
              return throwError(refreshErr);
            }
          })
        )
      } else {
        console.error('Error Url: ', err.error)
        if (err.url !== `${Api.url.base}auth/login`) {
          notificationService.error(extractErrorMessage(err));
        }
        return throwError(err);
      }
    })
  );
}

